const plugin = {}

plugin.install = function (Vue) {
  Vue.prototype.$datatable = function () {
    const $ = window.$
    let datatable = {}
    return {
      init: function (params) {
        const options = {
          data: {
            type: 'remote',
            source: {
              read: {
                method: params.method,
                url: params.url,
                map: function (raw) {
                  // sample data mapping
                  var dataSet = raw
                  if (typeof raw.data !== 'undefined') {
                    dataSet = raw.data
                  }
                  return dataSet
                }
              }
            },
            pageSize: params.size,
            saveState: {
              cookie: true,
              webstorage: true
            },
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true
          },
          // layout definition
          layout: {
            theme: 'default', // datatable theme
            class: '', // custom wrapper class
            scroll: false, // enable/disable datatable scroll both horizontal and vertical when needed.
            footer: false // display/hide footer
          },
          // column sorting
          sortable: true,
          pagination: true,
          toolbar: {
            // toolbar items
            items: {
              // pagination
              pagination: {
                // page size select
                pageSizeSelect: [10, 20, 30, 50, 100]
              }
            }
          },
          search: {
            input: $('#generalSearch')
          },
          // columns definition
          columns: params.columns
        }
        datatable = $('.m_datatable').mDatatable(options)
        return datatable
      },
      update: function (params) {
        let query = datatable.getDataSourceQuery()
        let keys = Object.keys(params)
        console.log(params)
        keys.forEach(function (key) {
          query[key] = params[key]
        })
        datatable.setDataSourceQuery(query)
        datatable.load()
      }
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// app/javascript/src/plugins/datatables/datatable.js